module.exports = __webpack_public_path__ + "static/media/filtro.da78e5fd.svg";